var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('a-row',{attrs:{"gutter":[16, 16]}},_vm._l((_vm.list),function(item,index){return _c('a-col',{key:index,attrs:{"xs":24,"sm":12,"lg":6}},[_c('CourseItem',{attrs:{"data":item}})],1)}),1)}
var staticRenderFns = []

export { render, staticRenderFns }